/**
 * @decorator
 */
export function FetchOnce() {
  return function(Class) {
    return class extends Class {
      shouldBackgroundReloadRecord(store, snapshot) {
        return false;
      }
    };
  };
}
